// Achievement sources (achievement authoring spec 6.1, 6.2). `ra` rows come
// from RetroAchievements, `hand` rows from code (gen-definitions.mjs), and
// `admin` rows from the authoring tool. A NULL source is a legacy row that the
// import still owns.

export const ACHIEVEMENT_SOURCES = Object.freeze(['ra', 'hand', 'admin']);
export const IMPORT_OWNED_SOURCES = Object.freeze(['ra', 'hand']);

export { AUTHORED_SLUG_RE } from './authored-slug.js';

const ITEM_ID_RE = /^[1-9][0-9]{0,17}$/;

/** True for rows the import and the BYO ingest may create, update or delete. */
export function isImportOwned(source) {
  return source === null || source === undefined || IMPORT_OWNED_SOURCES.includes(source);
}

/** True for rows RetroPlay made itself (code-defined or admin-authored). */
export function isRetroPlayMade(source) {
  return source === 'hand' || source === 'admin';
}

/** `au-<itemId>` for a positive safe integer or a decimal id string (BIGSERIAL from pg). */
export function authoredSlug(itemId) {
  let digits = null;
  if (typeof itemId === 'number' && Number.isSafeInteger(itemId) && itemId > 0) digits = String(itemId);
  else if (typeof itemId === 'string' && ITEM_ID_RE.test(itemId)) digits = itemId;
  if (digits === null) throw new TypeError(`authoredSlug: expected a positive item id, got a ${typeof itemId}`);
  return `au-${digits}`;
}
